import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faShieldHalved } from '@fortawesome/free-solid-svg-icons'

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <Navbar />
      <main className="pt-24 pb-16">
        <article className="max-w-3xl mx-auto px-4 sm:px-6 prose prose-slate">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-blue-600 mb-6 no-underline">
            <FontAwesomeIcon icon={faArrowLeft} className="w-3.5 h-3.5" />
            Kembali ke Beranda
          </a>
          <div className="flex items-center gap-3 mb-2">
            <FontAwesomeIcon icon={faShieldHalved} className="w-6 h-6 text-blue-600" />
            <h1 className="text-3xl font-bold text-slate-900 m-0">Kebijakan Privasi</h1>
          </div>
          <p className="text-slate-500 text-sm">Terakhir diperbarui: Juni 2026</p>

          <h2>1. Pendahuluan</h2>
          <p>
            Whistleblowing System (WBS) Pemerintah Provinsi Kalimantan Selatan berkomitmen melindungi
            privasi dan kerahasiaan data pelapor serta pengguna sistem. Kebijakan ini menjelaskan
            bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda.
          </p>

          <h2>2. Data yang Dikumpulkan</h2>
          <ul>
            <li>Data akun: nama, username, email, NIK, nomor telepon, dan alamat (jika diisi).</li>
            <li>Data laporan: isi laporan, lampiran bukti, metadata waktu dan lokasi kejadian.</li>
            <li>Data teknis: alamat IP, user agent, dan riwayat login untuk keamanan sistem.</li>
          </ul>

          <h2>3. Penggunaan Data</h2>
          <p>
            Data digunakan semata-mata untuk verifikasi, penanganan laporan, komunikasi resmi terkait
            laporan, dan peningkatan keamanan sistem. Data identitas pelapor anonim tidak dibuka
            tanpa persetujuan tertulis pelapor.
          </p>

          <h2>4. Perlindungan & Kerahasiaan</h2>
          <p>
            Kami menerapkan kontrol akses berbasis peran, enkripsi saat transmisi (HTTPS), dan
            pembatasan akses admin. Pelapor anonim dilindungi sesuai peraturan perlindungan whistleblower
            yang berlaku.
          </p>

          <h2>5. Hak Pengguna</h2>
          <p>
            Pengguna dapat memperbarui profil melalui menu Pengaturan. Permintaan penghapusan akun
            dapat diajukan kepada pengelola sistem melalui kanal resmi WBS Pemprov Kalsel.
          </p>

          <h2>6. Kontak</h2>
          <p>
            Pertanyaan terkait kebijakan privasi dapat disampaikan melalui kontak resmi yang
            tercantum di halaman utama WBS Pemprov Kalsel.
          </p>
        </article>
      </main>
      <Footer />
    </div>
  )
}
